import React, { Component } from 'react';
// import './login.scss';
import {Link} from 'react-router-dom'
import PropTypes from 'prop-types';


const RankingTableWithGroup=({poolRankingList,showTeamDetails})=>{
    if (!poolRankingList || !Array.isArray(poolRankingList)) return null;
    return(
        poolRankingList.map((rowData, index) => {
            const rows = Array.isArray(rowData) ? rowData : [];
            const firstRow = rows[0];
            const groupName = (firstRow && firstRow.group) || '';
            return (
                <table key={index} className="group-standing">
                    <tr>    
                        <th className="group-name">{groupName}</th>
                        <div className="group-content group-head">
                            <th>W</th>
                            <th>D</th>
                            <th>L</th>
                            <th>S</th>
                        </div>
                    </tr>
                    {rows.map((groupData, idx) => {
                        return (
                            // <Link to={'/teamDetails/'+groupData.team_id}>
                            <tr key={idx} className="team-content" onClick={()=>showTeamDetails(groupData)}>
                                {/* <td>
                                </td> */}
                                <td className="team-name">
                                    <span className="team-srno">{groupData.rank}.</span>
                                    {(groupData.teamName || (groupData.team && groupData.team.name)) === "South Sudan" ?
                                        <img src={require('./../../assets/images/south_sadan.png')}  className="team-flag"/>:
                                        <img src={groupData.team && groupData.team.logo}  className="team-flag"/>
                                                }
                                     <span style={{verticalAlign: 'super'}}>{(groupData.team && groupData.team.name) || ''}</span>
                                </td>
                                <div className="group-content">
                                    <td>{(groupData.all && groupData.all.win) != null ? groupData.all.win : 0}</td>
                                    <td>{(groupData.all && groupData.all.draw) != null ? groupData.all.draw : 0}</td>
                                    <td>{(groupData.all && groupData.all.lose) != null ? groupData.all.lose : 0}</td>
                                    <td>{groupData.points}</td>
                                </div>
                            </tr>
                            // </Link>
                        )
                    })}
                </table>
            )
        
        
        })
    )
    }

RankingTableWithGroup.propTypes = {
    poolRankingList: PropTypes.array,
    showTeamDetails: PropTypes.func,
};
export default RankingTableWithGroup;

